// extracted by mini-css-extract-plugin
module.exports = {"leadership-cards-list":"LeadershipList_leadership-cards-list__bOT7m","leadership-owners-list":"LeadershipList_leadership-owners-list__1aEeI"};